<template>
    <div id="container" class="container">
        <div id="searchBar">
            <input id="searchInput" ref="searchInput" type="text" :placeholder="$t('map_detail.search_panel.place_holder')" v-on:keyup="handleSearch" />
        </div>
        <div id="searchResults">
            <div id="searchResultsHeader" v-if="this.foundSearchableObjects.length != this.searchableObjects.length">{{ $tc('map_detail.search_panel.x_results_found', this.foundSearchableObjects.length, { nb_results: this.foundSearchableObjects.length }) }}</div>
            <ul>
                <li v-for="searchableObject in this.foundSearchableObjects" :key="searchableObject.getId()" v-bind:class="getSearchableObjectStyle(searchableObject)" v-on:click="handleSearchableObjectSelected($event, searchableObject)">
                    <img v-if="searchableObject.getType() != 'layer' && searchableObject.getIconUrl(true)" :src="searchableObject.getIconUrl(true)" class="icon" v-on:click="handleSearchableObjectSelected($event, searchableObject)" v-on:error="handleFailedLoadingImage($event, searchableObject)" />
                    <img v-if="searchableObject.getType() != 'layer' && !searchableObject.getIconUrl(true)" src="@/assets/searchable_object_default_icon.png" class="icon" v-on:click="handleSearchableObjectSelected($event, searchableObject)" />
                    <div class="title">{{ searchableObject.getName() }}</div>
                    <SwitchControl class="switch" v-model="searchableObject.visible" v-if="searchableObject.isHideable()"></SwitchControl>
                    <div class="status" v-bind:style="statusStyle(searchableObject)">{{ statusString(searchableObject) }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import SwitchControl from '@/components/ui/control/SwitchControl.vue';
import * as tinycolor from 'tinycolor2';
import LangUtils from '../../../utils/LangUtils';

export default {
    components: {
        SwitchControl
    },
    name: "MapSearchPanel",
    data: () => {
        return {
            foundSearchableObjects: Array,
            string_searchPlaceHolder: () => {
                return this.$t("message.hello");
            }
        }
    },
    props: {
        searchableObjects: Array,
        mapObjectStatusTemplates: null,
        allMapObjectStatus: null
    },
    watch: {
        searchableObjects: function() {
            this.foundSearchableObjects = this.searchableObjects;
        },

        allMapObjectStatus: function() {
            if (this.allMapObjectStatus) {
                this.$forceUpdate();
            }
        }
    },
    methods: {
        getSearchableObjectStyle(searchableObject) {
            const mapElement = searchableObject.mapElement;
            const status = this.findMapObjectStatusForMapElement(mapElement.id);

            return searchableObject.getType() == "layer" ? "section" : status ? "item item-with-status" : "item item-without-status"
        },

        statusStyle(searchableObject) {
            const mapElement = searchableObject.mapElement;
            const status = this.findMapObjectStatusForMapElement(mapElement.id);

            if (status) {
                const template = this.findMapObjectStatusTemplate(status.mapObjectStatusTemplateId);
                if (template) {
                    var fontColor = "#000000";
                    if (tinycolor(template.color).getBrightness() > 205) {
                        fontColor = tinycolor(template.color).darken(100);
                    } else {
                        fontColor = tinycolor(template.color).lighten(100);
                    }
                    return "background-color: " + template.color + "; color: " + fontColor;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },

        statusString(searchableObject) {
            const mapElement = searchableObject.mapElement;
            const status = this.findMapObjectStatusForMapElement(mapElement.id);

            if (status) {
                const template = this.findMapObjectStatusTemplate(status.mapObjectStatusTemplateId);
                if (template) {
                    return LangUtils.valueForLanguage(template.title, this.$i18n.locale);
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },

        handleSearchableObjectSelected(event, searchableObject) {
            this.$emit("searchable-object-selected", searchableObject.getId());
        },

        handleSearch() {
            const foundObjects = [];

            const searchedValue = this.$refs["searchInput"].value.toLowerCase();
            if (searchedValue.length == 0) {
                this.foundSearchableObjects = this.searchableObjects;
            } else {
                for (const searchableObject of this.searchableObjects) {
                    if (searchableObject.isSelectable()) {
                        const searchableObjectName = searchableObject.getName();
                        if (searchableObjectName && searchableObjectName.toLowerCase().indexOf(searchedValue) >= 0) {
                            foundObjects.push(searchableObject);
                        }
                    }
                }

                this.foundSearchableObjects = foundObjects;
            }
        },

        handleFailedLoadingImage(event, searchableObject) {
            if (event.target.src.indexOf("@2x.") >= 0) {
                event.target.src = searchableObject.getIconUrl(false);
            }
        },

        findMapObjectStatusForMapElement(mapElementId) {
            if (this.allMapObjectStatus) {
                for (var mapObjectStatus of this.allMapObjectStatus) {
                    if (mapObjectStatus.mapObjectId == mapElementId) {
                        return mapObjectStatus;
                    }
                }
            }
            return null;
        },

        findMapObjectStatusTemplate(mapObjectStatusTemplateId) {
            if (this.mapObjectStatusTemplates) {
                for (var mapObjectStatusTemplate of this.mapObjectStatusTemplates) {
                    if (mapObjectStatusTemplate.id == mapObjectStatusTemplateId) {
                        return mapObjectStatusTemplate;
                    }
                }
            }
            return null;
        }
    },
    mounted() {
        this.foundSearchableObjects = this.searchableObjects;
    }
}
</script>

<style lang="scss" scoped>
.container {
    display: flex;
    flex-flow: column;
    height: 100%;
    padding: 0px;
}

#searchBar {
    border-bottom: solid 1px #dddddd;
    flex: 0 1 auto;
    padding: 20px 20px 10px 20px;
    text-align: left;
}

#searchBar input {
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    font-size: 20px;
    width: 100%;
}

#searchResults {
    flex: 1 1 auto;
    height: 100%;
    overflow: scroll;
}

#searchResultsHeader {
    color: #aaaaaa;
    font-size: 12px;
    font-weight: bold;
    padding: 10px 20px;
    text-align: left;
}

#searchResults ul {
    padding: 0px;
}

#searchResults li {
    list-style-type: none;
}

#searchResults li .icon {
    grid-area: icon;
    display: inline-block;
    width: 40px;
    height: 40px;
}

#searchResults li .title {
    grid-area: title;
    align-self: center;
}

#searchResults li .switch {
    grid-area: switch;
    align-self: center;
}

#searchResults li .status {
    grid-area: status;
    align-self: left;
    background-color: #ff0000;
    border-radius: 5px;
    padding: 3px 5px;
    font-size: 12px;
}

#searchResults .section {
    display: grid;
    grid-template-columns: auto 60px;
    grid-template-rows: auto;
    grid-template-areas: "title switch";
    background-color: #224460;
    color: #ffffff;
    font-weight: bold;
    padding: 5px 20px;
    text-align: left;
}

#searchResults .section .status {
    display: none;
}

#searchResults .item-without-status {
    display: grid;
    grid-template-columns: 60px auto auto;
    grid-template-rows: auto auto;
    grid-template-areas: "icon title switch" "icon title switch";
    background-color: #ffffff;
    cursor: pointer;
    padding: 4px 20px;
    text-align: left;
}

#searchResults .item-with-status {
    display: grid;
    grid-template-columns: 60px auto auto;
    grid-template-rows: auto auto;
    grid-template-areas: "icon title switch" "icon status status";
    background-color: #ffffff;
    cursor: pointer;
    padding: 4px 20px;
    text-align: left;
}

#searchResults .item-without-status .status {
    display: none;
}

#searchResults .item:hover {
    background-color: #00ffff;
}
</style>